<template>
  <div class="svv-search-list" :class="activeTheme">
    <div class="ais-InstantSearch">
      <ais-instant-search
        :search-client="searchClient"
        :index-name="indexName"
        :routing="router"
        :search-function="searchFunction"
      >
        <ais-configure :filters="computeFilters" />
        <div
          class="ssws-selected-filter"
          v-if="sections.includes('currentRefiments')"
        >
          <ais-current-refinements :transform-items="refactorRefinements">
            <!-- The slot is the same as in the main library, it just supports html in the label -->
            <template slot="refinement" slot-scope="{ refinement, refine }">
              <span
                role="option"
                tabindex="0"
                class="ais-CurrentRefinements-categoryLabel"
                :aria-label="refinement.label"
              >
                <q v-if="refinement.attribute === 'query'"
                  ><span>{{ refinement.label }}</span></q
                >
                <span v-else v-html="refinement.label"></span>
              </span>
              <button
                role="button"
                tabindex="0"
                aria-label="tryck enter för att ta bort"
                class="ais-CurrentRefinements-delete"
                @click="refine(refinement)"
              >
                ✕
              </button>
            </template>
          </ais-current-refinements>
        </div>

        <div class="search-panel-wrapper" v-if="sections.includes('filters')">
          <div :class="activeTheme">
            <search-panel
              :filters="filters"
              :copy="copy"
              :selectedValuesList="selectedValuesList"
            ></search-panel>
          </div>
        </div>

        <div class="ssws-content-sec">
          <div class="ssws_stats">
            <ais-stats>
              <template v-slot="{ nbHits }">
                <div v-if="nbHits > 0">
                  <div class="ssws-intelliplan-list-header">
                    <span id="sdddd">{{ nbHits }}</span> {{ results_text }}
                  </div>
                </div>
                <div v-else>
                  <div class="ssws-intelliplan-list-header">
                    <span id="sdddd" style="display: none">{{ nbHits }}</span>
                    {{ no_results_text }}
                  </div>
                </div>
              </template>
            </ais-stats>
          </div>
        </div>
        <!-- <div class="search-panel__results full-width">
        <ais-infinite-hits :transform-items="transformItems">
          <template slot="item" slot-scope="{ item, index }">
            <component
              :is="getListComponent()"
              :index="index"
              :class="{ hidden: isHidden(index) }"
              :item="item"
              :copy="copy"
              :target="target"
            ></component>
          </template>
          <template
            slot="loadMore"
            v-if="copy.archive_pagination == 'pgination'"
          >
            <div class="addtional-css" :style="{ '--bkgImage': 'red' }"></div>
            <div class="nav-container" v-if="totalpages() > 1">
              <paginate
                :page-count="totalpages()"
                :page-range="3"
                :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'Föreg'"
                :next-text="'Nästa'"
                :container-class="getActiveTheme()"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </template>
          <template slot="loadMore" v-else>
            <div class="pagination loadMore-sec" v-if="totalpages() > 1">
              <span
                class="cust-loadMore-btn"
                :class="{
                  'cust-loadMore-btn--Disabled': pagination.isLastPage,
                }"
                @click="loadOnePage"
              >
                {{ copy.loadMoreLabel }}
              </span>
            </div>
          </template>
        </ais-infinite-hits>
      </div> -->

        <div class="search-panel__results full-width">
          <div class="pagination-type">
            <div
              class="main-pgination"
              v-if="copy.archive_pagination == 'pgination'"
            >
              <ais-hits :transform-items="transformItemshits">
                <template slot="item" slot-scope="{ item }">
                  <a
                    class="iteml-section"
                    :href="item.permalink"
                    :target="item.target"
                    :aria-labelledby="'heading-level_' + item.post_date"
                    aria-describedby="link-to-hemtjänst-maria"
                  >
                    <article>
                      <div
                        class="ssws-intelliplan-list"
                        style="background: #f6f6f6"
                      >
                        <div class="ssws-intelliplan-list-details">
                          <div class="heading-label">
                            {{
                              activeTheme && activeTheme == 'stendi-website'
                                ? 'Oppdrag'
                                : 'Uppdrag'
                            }}
                          </div>
                          <div class="heading">
                            <ais-highlight :hit="item" attribute="post_title" />
                          </div>
                          <div class="description">
                            <p v-if="item.short_content">
                              <span>{{ item.short_content }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="ssws-intelliplan-list-meta">
                          <div class="meta-section">
                            <div class="metainfo">
                              <div class="heading-label">
                                {{
                                  activeTheme && activeTheme == 'stendi-website'
                                    ? 'Avdeling'
                                    : 'Tjänstegrupp'
                                }}
                              </div>
                              <div
                                class="description"
                                v-for="servicecategory in item.taxonomies[
                                  'servicecategory'
                                ]"
                                :key="servicecategory.id"
                              >
                                {{ servicecategory }}
                              </div>
                            </div>
                            <div class="metainfo">
                              <div class="heading-label">
                                {{
                                  activeTheme && activeTheme == 'stendi-website'
                                    ? 'Sted'
                                    : 'Region'
                                }}
                              </div>
                              <div
                                class="description"
                                v-for="serviceregion in item.taxonomies[
                                  'serviceregion'
                                ]"
                                :key="serviceregion.id"
                              >
                                {{ serviceregion }}
                              </div>
                            </div>
                            <div class="metainfo">
                              <div class="heading-label">
                                {{
                                  activeTheme && activeTheme == 'stendi-website'
                                    ? 'Stilling'
                                    : 'Roller'
                                }}
                              </div>
                              <div
                                class="description"
                                v-for="role in item.taxonomies['role']"
                                :key="role.id"
                              >
                                {{ role }}
                              </div>
                            </div>
                            <div class="metainfo">
                              <div class="heading-label">Publicerat</div>
                              <div class="description">
                                {{ item.post_date_formatted }}
                              </div>
                            </div>
                          </div>
                          <div class="button-section">
                            <p
                              :target="item.target"
                              :href="item.permalink"
                              class="theme-btn-1"
                              :class="activeTheme"
                            >
                              {{ readmore_text }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </article>
                  </a>
                </template>
              </ais-hits>
              <div class="ais-pagination-cls">
                <ais-pagination />
              </div>
            </div>
            <div v-else>
              <ais-infinite-hits :transform-items="transformItemshits">
                <template slot="item" slot-scope="{ item }">
                  <a
                    class="iteml-section"
                    :href="item.permalink"
                    :target="item.target"
                    :aria-labelledby="'heading-level_' + item.post_date"
                    aria-describedby="link-to-hemtjänst-maria"
                  >
                    <article>
                      <div
                        class="ssws-intelliplan-list"
                        style="background: #f6f6f6"
                      >
                        <div class="ssws-intelliplan-list-details">
                          <div class="heading-label">
                            {{
                              activeTheme && activeTheme == 'stendi-website'
                                ? 'Oppdrag'
                                : 'Uppdrag'
                            }}
                          </div>
                          <div
                            class="heading"
                            :id="'heading-level_' + item.post_date"
                          >
                            <ais-highlight :hit="item" attribute="post_title" />
                          </div>
                          <div class="description">
                            <p v-if="item.short_content">
                              <span>{{ item.short_content }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="ssws-intelliplan-list-meta">
                          <div class="meta-section">
                            <div class="metainfo">
                              <div
                                v-if="
                                  item.taxonomies['servicecategory'].length >
                                    0 &&
                                  item.taxonomies['servicecategory'][0] != ''
                                "
                              >
                                <div class="heading-label">
                                  {{
                                    activeTheme &&
                                    activeTheme == 'stendi-website'
                                      ? 'Avdeling'
                                      : 'Tjänstegrupp'
                                  }}
                                </div>
                                <div
                                  class="description"
                                  v-for="servicecategory in item.taxonomies[
                                    'servicecategory'
                                  ]"
                                  :key="servicecategory.id"
                                >
                                  {{ servicecategory }}
                                </div>
                              </div>
                            </div>
                            <div class="metainfo">
                              <div
                                v-if="
                                  item.taxonomies['serviceregion'].length > 0 &&
                                  item.taxonomies['serviceregion'][0] != ''
                                "
                              >
                                <div class="heading-label">
                                  {{
                                    activeTheme &&
                                    activeTheme == 'stendi-website'
                                      ? 'Sted'
                                      : 'Region'
                                  }}
                                </div>
                                <div
                                  class="description"
                                  v-for="serviceregion in item.taxonomies[
                                    'serviceregion'
                                  ]"
                                  :key="serviceregion.id"
                                >
                                  {{ serviceregion }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="metainfo"
                              v-if="
                                item.end_date &&
                                activeTheme &&
                                activeTheme == 'stendi-website'
                              "
                            >
                              <div class="heading-label">Søknadsfrist</div>
                              <div class="description">
                                {{ item.end_date }}
                              </div>
                            </div>
                            <div
                              class="metainfo"
                              v-if="
                                item.post_date_formatted &&
                                activeTheme &&
                                activeTheme != 'stendi-website'
                              "
                            >
                              <div class="heading-label">Publicerat</div>
                              <div class="description">
                                {{ item.post_date_formatted }}
                              </div>
                            </div>
                            <div class="metainfo">
                              <div
                                v-if="
                                  item.taxonomies['role'].length > 0 &&
                                  item.taxonomies['role'][0] != ''
                                "
                              >
                                <div class="heading-label">
                                  {{
                                    activeTheme &&
                                    activeTheme == 'stendi-website'
                                      ? 'Stilling'
                                      : 'Roller'
                                  }}
                                </div>
                                <div
                                  class="description"
                                  v-for="role in item.taxonomies['role']"
                                  :key="role.id"
                                >
                                  {{ role }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="button-section">
                            <p
                              :target="item.target"
                              :href="item.permalink"
                              :class="activeTheme"
                              class="theme-btn-1"
                            >
                              {{ readmore_text }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </article>
                  </a>
                </template>
                <template v-slot:loadMore="{ page, isLastPage, refineNext }">
                  <div class="pagination loadMore-sec" :class="activeTheme">
                    <span
                      :aria-label="copy.loadMoreLabel"
                      role="button"
                      tabindex="0"
                      class="cust-loadMore-btn"
                      :class="{
                        'cust-loadMore-btn--Disabled': isLastPage,
                      }"
                      @click="refineNext"
                      v-on:keyup.enter="refineNext"
                    >
                      {{ copy.loadMoreLabel }}
                    </span>
                  </div>
                </template>
              </ais-infinite-hits>
            </div>
          </div>
        </div>
      </ais-instant-search>
    </div>
  </div>
</template>
<script>
/* eslint-disable prettier/prettier, no-console */
//import Vue from 'vue';
import SearchPanel from './components/searchPanel';
import router from './utility/router';
import localize from './utility/localize';
import 'instantsearch.css/themes/algolia-min.css';
import algoliasearch from 'algoliasearch';
import { createBrowserXhrRequester } from '@algolia/requester-browser-xhr';

/**
 * We need to replace client completely, old injection doesn't work anymore
 * Also need to update plugin, since settings section name is changed
 * 
 * @returns {Boolean|getClientProxy.localizedProxy|window.algolia.client_proxy|Window.algolia.client_proxy|String}
 */

const createSearchClient = () => {
    const localizedProxy = localize('svb_client_proxy');

    const clientProxy =
        typeof localizedProxy === 'string' && localizedProxy.length > 0
            ? localizedProxy
            : typeof window !== 'undefined' &&
                    window.algolia &&
                    typeof window.algolia.client_proxy === 'string'
              ? window.algolia.client_proxy
              : '';

    return algoliasearch(
        localize('svb_jobs_app') || '',
        localize('svb_jobs_api_key') || '',
        clientProxy
          ? {
              requester: {
                send(request) {
                  const requester = createBrowserXhrRequester();
                  const separator = clientProxy.includes('?') ? '&url=' : '?url=';

                  return requester.send({
                    ...request,
                    url: clientProxy + separator + request.url,
                  });
                },
              },
            }
          : undefined
    );
};


export default {
  components: {
    SearchPanel,
  },
  data() {
    return {
      router,
      dropdownToggle: {},
      items: [],
      searchClient: createSearchClient(),
      searchFunction(helper) {
        helper.search();
      },
      target: localize('svb_target_url') || 'self',
      selectedValuesList: {},
      getservicecategory: 'taxonomies.servicecategory',
      getServiceregion: 'taxonomies.serviceregion',
      getRole: 'taxonomies.role',
      is_counter: true,
      isSortIp: true,
      indexName: localize('svb_jobs_index') || '',
      showServiceGroupyBox: localize('showServiceGroupyBox') || '',
      ServiceGroupLabel: localize('ServiceGroupLabel') || 'Tjänstegrupp',
      ServiceGroupPlaceholder:
        localize('ServiceGroupPlaceholder') || 'Service Group',
      showCountyBox: localize('showCountyBox') || '',
      CountyLabel: localize('CountyLabel') || 'County',
      CountyPlaceholder: localize('CountyPlaceholder') || 'region',
      activeTheme: localize('svb_active_theme') || '',
      showRollerBox: localize('showRollerBox') || '',
      RollerLabel: localize('RollerLabel') || 'Roller',
      RollerPlaceholder: localize('RollerPlaceholder') || 'Roller placeholder',
      filters: ['search', 'servicecategory', 'serviceregion', 'role'],
      sections: localize('sections') || ['filters', 'currentRefiments'],
      SearchButtonText: localize('SearchButtonText') || 'Search',
      currentRefinement: '',
      filterLimit: 5,
      no_results: localize('no_results') || '',
      searchVal: localize('searchVal') || 'Search',
      targetPage: localize('svb_target_url') || '',
      showCategoryBox: localize('showCategoryBox') || false,
      results_text: localize('results_text') || 'Results found',
      no_results_text: localize('no_results_text') || 'No result',
      Searchlabel: localize('Searchlabel') || 'Search',
      Searchplaceholder: localize('Searchplaceholder') || 'Search placeholder',
      showSearchBox: localize('showSearchBox') || false,
      allcategoryPlace: localize('allcategoryPlace') || 'All category',
      CategoryPlace: localize('CategoryPlace') || 'Category placeholder',
      readmore_text: localize('readmore_text') || 'Läs mer och boka',
      addrefinement: 'servicecategory',
      addrefinement2: false,
      copy: {
        loadMoreLabel: localize('View_more_units') || 'View more businesses',
        archive_pagination:
          localize('archive_pagination').archive_pagination || 'load_more',
        ServiceGroupLabel: localize('ServiceGroupLabel') || 'Tjänstegrupp',
        ServiceGroupPlaceholder:
          localize('ServiceGroupPlaceholder') || 'Service Group',
        CountyLabel: localize('CountyLabel') || 'County',
        CountyPlaceholder: localize('CountyPlaceholder') || 'region',
        RollerLabel: localize('RollerLabel') || 'Roller',
        RollerPlaceholder:
          localize('RollerPlaceholder') || 'Roller placeholder',
        readmore_text: localize('readmore_text') || 'Läs mer och boka',
        Searchplaceholder:
          localize('Searchplaceholder') || 'Search placeholder',
        Searchlabel: localize('Searchlabel') || 'Search',
      },
      pagination: {
        hitsPerPage: parseInt(localize('hitsPerPage')) || 20,
        currentPage: -1,
        totalItems: false,
        isLastPage: false,
      },
    };
  },
  computed: {
    markers() {
      if (!this.items || !this.sections.includes('map')) {
        return [];
      }

      return this.computeMarkers(this.items);
    },
    computeFilters() {
      let searchExclude = localize('addrefinement')
        ? localize('addrefinement')
        : '';
      let exculdeElement = searchExclude.split(',');
      var p = '';
      if (Array.isArray(exculdeElement)) {
        p = '(';
        exculdeElement.forEach((currentValue, index) => {
          if (index < exculdeElement.length - 1) {
            p += 'taxonomies.servicecategory:"' + currentValue + '"';
            p += ' OR ';
          } else {
            p += 'taxonomies.servicecategory:"' + currentValue + '"';
          }
        });
        p += ')';
      }
      if (localize('addrefinement').length == 0) {
        return '';
      } else {
        return p;
      }
    },
  },
  filters: {
    strippedContent: function (string) {
      return string.replace(/<\/?[^>]+>/gi, ' ');
    },
  },
  methods: {
    getListComponent() {
      var componentName = 'list-item';

      return componentName;
    },
    themepagination() {
      let colorName;
      if (this.activeTheme === 'vardaga-2021') {
        colorName = '#de3f2a';
      } else {
        colorName = '#6ab651';
      }
      return colorName;
    },
    getActiveTheme() {
      let t1;
      if (this.activeTheme === 'vardaga-2021') {
        t1 = 'vardaga_pagination';
      } else {
        t1 = 'pagination';
      }
      return t1;
    },
    clickCallback(pageNum) {
      this.pagination['currentPage'] = pageNum - 1;
      console.log('lp', pageNum);
    },
    totalpages() {
      return Math.ceil(
        this.pagination['totalItems'] / this.pagination['hitsPerPage']
      );
    },
    computeMarkers(items) {
      console.log('items', items);
      var markers = [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];

        if (!item._geoloc) {
          continue;
        }

        var marker = {
          position: {
            lat: '',
            lng: '',
          },
          postTitle: '',
          image: '',
          tjanst: '',
          malgrupp: '',
          permalink: '',
          address: '',
        };

        marker.position = {
          lat: item._geoloc.lat,
          lng: item._geoloc.lng,
        };

        if (item.post_title) {
          marker.postTitle = item.post_title;
        }
        if (item.images && item.images.medium) {
          marker.image = item.images.medium.url;
        }
        if (item.taxonomies['Tjänst']) {
          marker.tjanst = item.taxonomies['Tjänst'].join(', ');
        }
        if (item.taxonomies['Målgrupp']) {
          marker.malgrupp =
            '<strong>' +
            this.copy.targetGroup +
            ': </strong>' +
            item.taxonomies['Målgrupp'].join(', ');
        }
        if (item.permalink) {
          marker.permalink = item.permalink;
        }

        if (
          this.activeTheme != 'altiden-2022' &&
          this.activeTheme != 'stendi-website' &&
          item.metadata &&
          item.metadata.ssws_location &&
          item.metadata.ssws_location.address
        ) {
          marker.address = this.getAddressString(
            item.metadata.ssws_location.address
          );
        }

        markers.push(marker);
      }

      return markers;
    },
    getAddressString(addressObj) {
      var address = '';

      if (
        typeof addressObj.street !== 'undefined' &&
        addressObj.street !== ''
      ) {
        address += addressObj.street + ' ';
      }

      if (typeof addressObj.zip !== 'undefined' && addressObj.zip !== '') {
        address += addressObj.zip + ' ';
      }

      if (address !== '') {
        if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
          address += addressObj.city + ' ';
        }
        return address.trim();
      }

      if (typeof addressObj.city !== 'undefined' && addressObj.city !== '') {
        return addressObj.city.trim();
      }

      if (
        typeof addressObj.municipality !== 'undefined' &&
        addressObj.municipality !== ''
      ) {
        return addressObj.municipality.trim();
      }

      if (
        typeof addressObj.region !== 'undefined' &&
        addressObj.region !== ''
      ) {
        return addressObj.region.trim();
      }

      return '';
    },
    refactorRefinements(items) {
      return items;
    },
    checkIfLastPage() {
      let lastIndex = this.pagination['totalItems'] - 1;
      let from =
        this.pagination['currentPage'] * this.pagination['hitsPerPage'];
      let to = from + this.pagination['hitsPerPage'] - 1;

      if (lastIndex >= from && lastIndex <= to) {
        return true;
      }

      return false;
    },
    transformItems(items) {
      /*
      Better would be to check for different Objects, but pagination works well enough even when looking for different items.length.
      */
      if (items.length !== this.items.length) {
        this.pagination['currentPage'] = 0;
        this.pagination['totalItems'] = 134;
        this.pagination['isLastPage'] = this.checkIfLastPage();

        this.items = JSON.parse(JSON.stringify(items));
      }

      return items;
    },
    isHidden(currentIndex) {
      if (this.copy.archive_pagination == 'pgination') {
        let from =
          this.pagination['currentPage'] * this.pagination['hitsPerPage'];
        let to = from + this.pagination['hitsPerPage'] - 1;
        if (currentIndex >= from && currentIndex <= to) {
          console.log(currentIndex);
          return false;
        } else {
          return true;
        }
      } else {
        let from =
          this.pagination['currentPage'] * this.pagination['hitsPerPage'];
        let to = from + this.pagination['hitsPerPage'] - 1;

        if (currentIndex <= to) {
          return false;
        }

        return true;
      }
    },
    loadOnePage() {
      if (this.pagination['isLastPage']) {
        return;
      }

      this.pagination['currentPage']++;
      this.pagination['isLastPage'] = this.checkIfLastPage();
    },
  },
};
</script>
<style>
.stendi-website .multiselect__option--highlight,
.stendi-website .label_count {
  background-color: #b8460f !important;
}
.stendi-website p.theme-btn-1 {
  background-color: #b8460f !important;
}
.stendi-website
  .ledige-stillinger
  .search-panel
  .multiselect__option--highlight {
  background-color: #b8460f !important;
}
.stendi-website p.theme-btn-1.stendi-website {
  background-color: #b8460f !important;
}

.cust-loadMore-btn {
  background: #4a4a49;
  color: #fff;
  text-decoration: none !important;
  display: inline-block;
  padding: 14px 32px 11px 32px !important;
  border-radius: 100px;
  text-align: center;
  cursor: pointer;
  font-size: 18px !important;
  line-height: 28px;
  border-radius: 100px;
  border: solid 2px #4a4a49;
}
/* .vardaga-2021 .cust-loadMore-btn {
    background: #de3f2a !important;
} */
.svv-search-list .cust-loadMore-btn {
  cursor: pointer;
}
button.ais-InfiniteHits-loadMore.ais-InfiniteHits-loadMore--disabled {
  display: none;
}
.svv-search-list .cust-loadMore-btn.cust-loadMore-btn--Disabled {
  cursor: default;
  opacity: 0.5;
}
.svv-search-list .ais-InfiniteHits-item {
  margin-left: 0;
  padding: 0;
  border: 0;
  margin-top: 0;
  flex-basis: 100%;
  box-shadow: none;
}
.svv-search-list .ais-InfiniteHits-list {
  margin-left: 0;
  margin-top: 0;
}
.ais-CurrentRefinements .ais-CurrentRefinements-categoryLabel > span > span {
  font-size: 0.9rem;
}

.svv-search-list h3.item-title {
  margin: 0px !important;
}

.nav-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.nav-container ul {
  margin: 15px 0;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  border-radius: 3px;
  border: 1px solid #ccc;
}
.nav-container ul li {
  list-style: none;
  border-right: 1px solid #ccc;
  margin: 0;
  display: inline-block;
}
.nav-container ul li:last-child {
  border-right: none;
}

.nav-container ul li.disabled {
  display: none;
}
.nav-container ul li a {
  display: inline-block;
  text-decoration: none !important;
  border: none;
  font-weight: bold;
  color: #000 !important;
  padding: 6px 20px;
  font-size: 14px;
  letter-spacing: 0;
  min-width: 35px;
  text-align: center;
}
.nav-container ul li a:hover,
.nav-container ul li.active a {
  background: #de3f2a !important;
  color: #fff !important;
}
.nav-container ul.pagination li a:hover,
.nav-container ul.pagination li.active a {
  background: #6ab651 !important;
  color: #fff !important;
}
p.theme-btn-1.vardaga-2021 {
  background-color: #de3f2a !important;
  color: #fff !important;
}
p.theme-btn-1.nytida-2020 {
  background-color: #6ab651 !important;
  color: #fff !important;
}
p.theme-btn-1.altiden-2021 {
  background-color: #f18626 !important;
  color: #fff !important;
}
p.theme-btn-1.altiden-2022 {
  background-color: #f18626 !important;
  color: #fff !important;
}
p.theme-btn-1.lara-2021 {
  background-color: #0075bf !important;
  color: #fff !important;
}
p.theme-btn-1.stendi-website {
  background-color: #b8460f !important;
  color: #fff !important;
}
a.iteml-section .theme-btn-1 {
  padding: 15px 18px !important;
}

.svv-search-form .multiselect__tag i:after {
  color: #fff;
  font-size: 100%;
}
a.iteml-section:focus,
a.iteml-section:focus-visible,
a.iteml-section:focus-within {
  outline: 3px solid #177ffb;
  border-radius: 3px;
}
a.iteml-section {
  display: block;
}
.klara-2022 .search-panel .multiselect__option--highlight,
.klara-2022 .search-panel .multiselect__content-wrapper .label_count {
  background: #6ab651 !important;
}

.svv-search-form .multiselect__tag i {
  line-height: 1;
  font-size: 20px;
  font-weight: normal;
  top: -1px;
}
.svv-search-list .multiselect__input,
.svv-search-list .multiselect__single {
  font-size: 18px;
  margin: 0;
  padding: 0;
  top: 6px;
}
.search-panel .multiselect__option--selected.multiselect__option--highlight {
  background: #de3f2a !important;
  color: #fff !important;
}

.button-section a.vardaga-2021 {
  background: #de3f2a !important;
  color: #fff !important;
}
.multiselect__option span.option_label {
  position: relative;
  z-index: 0;
}
.svv-search-list .multiselect__tags {
  padding: 7px 40px 0 8px;
  border-radius: 0;
  border: 1px solid #d2d2d1;
  font-size: 18px;
  min-height: 45px;
}
a.iteml-section {
  width: 100%;
  color: #000 !important;
}
.svv-search-list .multiselect__select:before {
  border-color: #212529 transparent transparent;
}
.svv-search-list .multiselect__input,
.svv-search-list .multiselect__single {
  font-size: 18px;
  margin: 0;
  padding: 0;
  top: 6px;
}
.svv-search-list .multiselect__placeholder {
  color: #212529;
  margin: 0 0 7px 0;
  white-space: nowrap !important;
}
.svv-search-list
  .ais-InstantSearch
  .ais-InfiniteHits
  .ais-InfiniteHits-list
  .ais-InfiniteHits-item
  .ssws-item-section
  h3.item-title {
  color: #000 !important;
}
.svv-search-list
  .ais-InstantSearch
  .ais-InfiniteHits
  .ais-InfiniteHits-list
  .ais-InfiniteHits-item
  .ssws-item-section
  .e-post
  a {
  overflow-wrap: break-word;
}
.search-panel .down-arrow {
  display: inline-grid;
  align-items: center;
}
.h3style {
  margin: 0px !important;
  color: #000 !important;
}
.h3style span {
  font-size: 1.5rem !important;
  font-family: BrownLLWeb-Bold;
}
.ssws_search_panel-tab-button.more-btn:focus,
.ssws_search_panel-tab-button.more-btn:focus-visible,
.ssws_search_panel-tab-button.more-btn:focus-within,
.search-panel__filters.more-filters:focus,
.search-panel__filters.more-filters:focus-visible,
.search-panel__filters.more-filters:focus-within {
  outline: 3px solid #177ffb;
  border-radius: 3px;
}
a.iteml-section {
  text-decoration: none !important;
}
@media (min-width: 991px) {
  .ssws-item-section {
    justify-content: space-between;
  }
  .ssws-item-section .right-sec {
    min-width: 250px !important;
    width: auto !important;
    max-width: 250px !important;
  }
}
@media (max-width: 767px) {
  .svv-search-list
    .ais-InstantSearch
    .ais-InfiniteHits
    .ais-InfiniteHits-list
    .ais-InfiniteHits-item
    .ssws-item-section
    a.iteml-section {
    flex-direction: column;
  }
  .svv-search-list
    .ais-InstantSearch
    .search-panel
    .ssws_search_panel-tab-button.more-btn {
    justify-content: flex-end;
  }
  .ais-InstantSearch
    .ais-CurrentRefinements
    .ais-CurrentRefinements-item
    .ais-CurrentRefinements-category
    button.ais-CurrentRefinements-delete {
    position: initial !important;
    margin-left: 10px !important;
  }
}
</style>
